import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'CarbonCalculator',
          path: '',
          component: () => import('@/views/CarbonCalculator'),
        },
        // Tables
        {
          name: 'Contact',
          path: 'contact',
          component: () => import('@/views/Contact'),
        },
      ],
    },
  ],
})
